var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Draggable',_vm._g({attrs:{"root-offset":_vm.rootOffset,"prevent-default":_vm.preventDefault,"stop-propagation":_vm.stopPropagation,"drag-data":_vm.dragData},on:{"move":_vm.onMove,"mouseup":_vm.onMouseUp}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }